import { render, staticRenderFns } from "./AssessmentNavigator.vue?vue&type=template&id=085036da&scoped=true&"
import script from "./AssessmentNavigator.vue?vue&type=script&lang=js&"
export * from "./AssessmentNavigator.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentNavigator.vue?vue&type=style&index=0&id=085036da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085036da",
  null
  
)

export default component.exports